import {ChangeDetectionStrategy, Component, computed, DestroyRef, effect, ElementRef, Injectable, Injector, input, OnDestroy, output, Signal, signal, TemplateRef, viewChild, ViewContainerRef,} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidatorFn, Validators} from '@angular/forms';
import {AgendaelementId, BeslutningIndeksfelter, DokumentRessursClient, DokumentVersjonId, DokumentVersjonModell, ElasticSearchResultat, ElasticSearchTreff, GruppeId, HttpsUrl, IndeksertEntitet, InternlenkeMålEntitetType, OppgaveIndeksfelter, OpplastetDokumentVersjonIndeksfelter, SakIndeksfelter, SøkEntitetType, SøkRessursClient, SøkSpesifikasjon} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatButton, MatIconButton, MatMiniFabButton} from "@angular/material/button";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";
import {erIkkeTomStreng, erLikIgnorerCasing, erStreng, erTomEllerNil} from "felles-ng2/støttefunksjoner/strenger";
import {TranslateModule} from "@ngx-translate/core";
import {AutoSizeInputDirective} from "ngx-autosize-input";
import {MatFormFieldModule} from "@angular/material/form-field";
import {takeUntilDestroyed, toObservable, toSignal} from "@angular/core/rxjs-interop";
import {concatMap, debounceTime, filter, fromEvent, Observable, startWith, switchMap, tap} from "rxjs";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {map} from "rxjs/operators";
import {entitetTypeFraTreff} from "felles-ng2/modell/indekssøkeresultatModellHjelpere";
import {KlikkMedStopPropagationDirektiv} from "web-ng2/delt/direktiver/klikkMedStopPropagation/klikkMedStopPropagation";
import {Overlay, OverlayConfig, OverlayRef} from "@angular/cdk/overlay";
import {TemplatePortal} from "@angular/cdk/portal";
import {DokumentInlinePdfviserKomponent} from "web-ng2/moduler/dokument/komponenter/dokument-inline-pdfviser/dokument-inline-pdfviser";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {SøkVisTreffKomponent} from "web-ng2/moduler/søk/komponenter/søk-vis-treff/søk-vis-treff";
import {MatChipsModule} from "@angular/material/chips";
import {VelgSøkbareEntiteterKomponent} from "web-ng2/moduler/søk/komponenter/velg-søkbare-entiteter/velg-søkbare-entiteter";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {InterneLenker} from "felles-ng2/tjenester/InterneLenker";
import {erHttpsUrl} from "felles-ng2/støttefunksjoner/uri";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {distinctUntilChangedDeep, logVerdiLevert} from "felles-ng2/støttefunksjoner/observable";
import {AgendaelementModellDLM, SakDatatjeneste} from "felles-ng2/tjenester/datalager/SakDatatjeneste";
import {fraMillisSidenEpostTilZoneDateTime, lesZonedDateTimeSerialisert, plainDateFraZonedDateTime} from "felles-ng2/støttefunksjoner/temporal";
import {TemporalFormatering} from "felles-ng2/tjenester/TemporalFormatering";
import {GjeldendeTidssone} from "felles-ng2/tjenester/i18n/GjeldendeTidssone";
import {EntitetId} from "felles-ng2/tjenester/ressurser/ng2HttpKlientTilleggstyper";
import {Tastatur} from "felles-ng2/støttefunksjoner/tastaturhendelser";
import {MatTooltip} from "@angular/material/tooltip";
import {MatDatepickerModule} from '@angular/material/datepicker';
import {VelgSøkeperiodeKomponent} from "web-ng2/moduler/søk/komponenter/velg-søkeperiode/velg-søkeperiode";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import {PlainDatePeriode, plainDatePeriodeSomZonedDateTimePeriode} from "felles-ng2/støttefunksjoner/plainDatePerioder";
import {ZonedDateTimePeriodeLukketSerialisert} from "felles-ng2/typer/ZonedDateTimePeriode";
import {asynkArbeidPågårSignal} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {caseForEnumMangler} from "felles-ng2/støttefunksjoner/enumer";
import {erInternLenke, indeksertEntitetFraInternlenkeMålEntitetType, InternlenkeAttributter, internlenkeTypeFraSøketreff, LenkeAttributter} from "felles-ng2/modell/lenkerelasjonModellHjelper";
import {SakVisKompaktKomponent} from "web-ng2/moduler/sak/komponenter/sak-vis-kompakt/sak-vis-kompakt";
import {internlenkeUuidGenerator} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/tiptap/utvidelser/Lenke";
import {fadeInnAnimasjon} from "web-ng2/delt/animasjoner";
import {MatListOption, MatSelectionList} from "@angular/material/list";
import {nårGuiErOppdatert} from "felles-ng2/infrastruktur/angular/nårGuiErOppdatert";
import {erIkkeTomListe} from "felles-ng2/støttefunksjoner/lister";
import {MeldingTilBrukerNg2} from "felles-ng2/tjenester/MeldingTilBrukerNg2";
import {oppdaterSignal} from "felles-ng2/støttefunksjoner/signal";
import {MillisSidenEpochSomZonedDateTime} from "felles-ng2/pipes/millisSidenEpochSomZonedDateTime";

const debug = initDebugger('LenkeRedigerKomponent');

type SkjemaType = RiktekstRedigeringLenkeRedigerKomponent['skjema'];
type SkjemaVerdier = SkjemaType['value'];

/** Gui for redigering av lenke.
 * Bruker kan angi en https-adresse eller søke etter entitiet og lage lenke til denne. */
@Component({
    selector: 'riktekst-redigering-lenke-rediger',
    templateUrl: 'lenke-rediger.html',
    styleUrl: 'lenke-rediger.scss',
    host: {'data-testid': 'riktekst-redigering-lenke-rediger'},
    animations: [fadeInnAnimasjon('200ms')],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatButton,
        MatIconButton,
        MatIcon,
        TranslateModule,
        AutoSizeInputDirective,
        MatFormFieldModule,
        SakVisKompaktKomponent,
        KlikkMedStopPropagationDirektiv,
        DokumentInlinePdfviserKomponent,
        ZonedDateTimeSomPlainDatePipe,
        FormaterPlainDatePipe,
        SøkVisTreffKomponent,
        MatMiniFabButton,
        MatChipsModule,
        VelgSøkbareEntiteterKomponent,
        MatSlideToggle,
        MatTooltip,
        MatDatepickerModule,
        VelgSøkeperiodeKomponent,
        MatProgressSpinner,
        MatSelectionList,
        MatListOption,
        MillisSidenEpochSomZonedDateTime
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiktekstRedigeringLenkeRedigerKomponent implements OnDestroy {

    /** tekstfelt der bruker kan rediger adresse / søke etter entitet */
    readonly adressefelt = viewChild<ElementRef<HTMLInputElement>>('adressefelt');
    readonly soekeresultatListing = viewChild<MatSelectionList>('soekeresultatListing');

    readonly vedSetAdresse = output<EksternEllerInternLenkeSpesifikasjon>();
    readonly vedSlettLenke = output();
    readonly vedAvbryt = output();

    /** Eksisterende lenke.
     * {@link Lenkeinformasjon#adresse} er null dersom dette er en ny lenke.
     * {@link Lenkeinformasjon#lenketekst} vil inneholde eventuell tekst som var markert når dialogen ble initiert */
    readonly eksisterendeLenke = input.required<Lenkeinformasjon>();
    /** GruppeId som som begrenser hvilke grupper søk etter entitet skjer i, dersom null eller ikke angitt vil ikke søk etter entitet være tilgjengelig */
    readonly gruppeId = input<GruppeId | null>(null);
    readonly kunVisModus = input(false);
    /** Panelet denne komponenten vises i, null dersom den ikke er vist i et overlaypanel (se {@link Lenkepanel})*/
    readonly panel = input<OverlayRef | null>(null);

    /** Alle entitettyper som kan opptre i søkeresultatet */
    readonly entitettyper = IndeksertEntitet;
    /** entitettyper vi kan begrense søket til */
    readonly tilgjengeligeTyper = [SøkEntitetType.sak, SøkEntitetType.dokument, SøkEntitetType.beslutning, SøkEntitetType.oppgave];
    readonly skjema = new FormGroup({
        /** tekstfelt der bruker kan angitt adresse (url) eller søke etter entitet det skal lages lenke til */
        adresse: new FormControl<string>('', {nonNullable: true, validators: [Validators.required, this.adresseValidator()]}),
        /** entitettyper søket etter entitet skal begrenses til */
        inkluderteTyper: new FormControl(this.tilgjengeligeTyper, {nonNullable: true}),
        periode: VelgSøkeperiodeKomponent.opprettSkjemaMedEttÅrTilbakeOgEttÅrFrem(this.klokke),
    });
    readonly oppdaterLenketekstKontroll = new FormControl(false, {nonNullable: true});
    readonly valgtTreffKontroll = new FormControl<ElasticSearchTreff<any>[] | null>(null, {nonNullable: true});

    readonly modus = signal<'ny' | 'rediger' | 'vis'>('vis');
    readonly adressefeltPlaceholder = computed(() => this.oversettelser.oversett(erIkkeNil(this.gruppeId()) ?
      i18n('Lim inn lenke eller søk etter innslag i Styreplan') : i18n('Lim inn lenke')));

    /** sann dersom den eksisterende lenken vi redigerer er intern */
    readonly eksisterendeLenkeErIntern = computed(() => erInternLenke(this.eksisterendeLenke().attributter));
    /** {@link ElasticSearchTreff} representasjon av eksisterende internlenke dersom */
    eksisterendeInternlenkeSomTreff = toSignal(toObservable(this.eksisterendeLenke).pipe(
      filter(lenk => erInternLenke(lenk.attributter)),
      switchMap(lenke => this.lastElasticSearchTreffRepresentasjonAvEntitet(lenke.attributter.dataId!, lenke.attributter.dataType!))), {initialValue: null});
    /** Sann dersom lasting av entitet eksisterende intern lenke peker til fra indeks feilet */
    lastingAvInternlenkeSomTreffFeilet = signal(false);
    /** lenketekst for eksisterende internlenke, beregnet utfra entitet lenken peker til */
    eksisterendeInternlenkeSomLenketekst = computed(() => erIkkeNil(this.eksisterendeInternlenkeSomTreff()) ?
      this.lenketekstForTreff(this.eksisterendeInternlenkeSomTreff()!) : '');
    /** sann dersom {@link #eksisterendeInternlenkeSomLenketekst} (lenketekst basert på entitet lenken faktisk peker til)
     * er ulik {@link #eksisterendeLenke}.lenketekst (en tekst bruker kan ha redigert) */
    eksisterendeInternlenkeHarAvvikendeLenketekst = computed(() => erIkkeNil(this.eksisterendeInternlenkeSomTreff()) ?
      !erLikIgnorerCasing(this.eksisterendeLenke().lenketekst, this.eksisterendeInternlenkeSomLenketekst()) :
      false);
    /** skjema.adresse som signal */
    adressefeltVerdi = toSignal(this.skjema.controls.adresse.valueChanges);
    adresseHarForFaaTegnForSoek = computed(() => this.erForKortSøkestreng(this.adressefeltVerdi()));
    /** Sann dersom tekst i adressefeltet er en http-adresse */
    adresseErAntattEkstern = computed(() => erNil(this.valgtTreff()) && this.erAntattEksternAdresse(this.adressefeltVerdi()));
    /** Sann dersom vi er i redigeringsmodus og lenketekst for eksisterende lenke er ulik http-adressen i adressefeltet eller ulik beregnet lenketekst for valgt treff fra søkeresultatlisten */
    lenketekstAvvikerFraRedigertAdresse = computed(() => {
        if (this.modus() == 'vis') return false;
        if (erIkkeNil(this.valgtTreff()) && !erLikIgnorerCasing(this.eksisterendeLenke().lenketekst, this.adressefeltVerdi())) return true;
        if (this.adresseErAntattEkstern() && !erLikIgnorerCasing(this.eksisterendeLenke().lenketekst, this.adressefeltVerdi())) return true;
        return false;
    });

    /** søkeresultatene som vises i mat-autocomplete */
    readonly viserSoekeresultat = signal(false);
    readonly soekeresultat: Signal<ElasticSearchTreff<any>[]>;
    readonly soekPaagaar = asynkArbeidPågårSignal();
    /** Treff som bruker har valgt fra soekeresultat listen, null ved ekstern lenke eller bruker enda ikke har valgt noe treff */
    readonly valgtTreff = signal<ElasticSearchTreff<any> | null>(null);
    /** Treff bruker har valgt å vise forhåndsvisning av */
    readonly forhaandsvisningAvTreff = signal<ElasticSearchTreff<any> | null>(null);
    readonly forhaandsvisningAvTreffSomSak = computed(() => this.forhaandsvisningAvTreff()?._source as SakIndeksfelter);
    readonly forhaandsvisningAvTreffSomDokumentversjon = signal<DokumentVersjonModell | null>(null);

    private forhåndsvisningPanel: OverlayRef | null = null;
    private readonly forhåndsvisningFragment = viewChild.required<TemplateRef<ElementRef>>('forhaandsvisningFragment')


    constructor(private avhengigheter: RiktekstRedigeringLenkeRedigerKomponentAvhengigheter,
                private oversettelser: Oversettelser,
                private klokke: Klokke,
                private interneLenker: InterneLenker,
                private temporalFormatering: TemporalFormatering,
                private gjeldendeTidssone: GjeldendeTidssone,
                private meldingTilBruker: MeldingTilBrukerNg2,
                private overlay: Overlay,
                private viewContainerRef: ViewContainerRef,
                private destroyRef: DestroyRef,
                private injector: Injector) {
        //gå til redigeringsmodus dersom eksisterendeLenke.adresse er satt til tom streng, ellers aktiveres visningsmodus
        toObservable(this.eksisterendeLenke)
          .pipe(distinctUntilChangedDeep()) //kun lever når innholdet i eksisterendeLenke har blitt endret
          .subscribe(lenkeinformasjon => {
              debug(`eksisterendeLenke endret til: %o`, lenkeinformasjon);
              if (erNil(lenkeinformasjon)) return;
              if (erTomEllerNil(lenkeinformasjon.adresse)) this.rediger()
              else this.aktiverVismodus();
          })

        //når bruker klikker på et søketreff setter vi adressefeltet til generert lenketekst for treffet og skjuler søkeresultatlisten
        const adresseOppdatertFraTreff = signal(false);
        this.valgtTreffKontroll.valueChanges
          .pipe(
            filter(erIkkeTomListe),
            map(valgte => valgte[0]),
            takeUntilDestroyed())
          .subscribe(valgtTreff => {
              this.skjulSøkeresultat();
              this.valgtTreff.set(valgtTreff);
              //sørg for at endring av adresse ikke trigger noe søk
              adresseOppdatertFraTreff.set(true);
              this.skjema.controls.adresse.setValue(this.lenketekstForTreff(valgtTreff));
              this.adressefelt()?.nativeElement.focus();
          });

        //håndter søking
        this.soekeresultat = toSignal(this.skjema.valueChanges
            .pipe(
              //søk er ikke tilgjengelig dersom gruppeId ikke er angitt
              filter(() => erIkkeNil(this.gruppeId())),
              //ikke utfør søk dersom skjema.adresse er oppdatert som følge av at bruker har valgt et treff
              filter(() => !oppdaterSignal(adresseOppdatertFraTreff, false)),
              map(skjema => this.søkespesifikasjon(skjema)),
              //utfør søk kun når spesifikasjon faktisk har blitt endret,
              //uten denne blir det mange leveranser av identiske spesifikasjoner fordi velg-søkeperiode via mat-date-range-input leverer verdi hver gang markør flyttes inn i datofeltet
              distinctUntilChangedDeep(),
              //signaliserer at søk starter - gjør dette før debounce for å unngå at dette først skjer etter 200ms, og kun dersom søkestreng er lang nok
              tap(spesifikasjon => {
                  if (!this.erForKortSøkestreng(spesifikasjon.soekestreng)) this.soekPaagaar.set(true);
              }),
              //utfør søk med minimum 600ms mellomrom (samme debounce som benyttes i det globale søket på toppen av alle sider)
              debounceTime(600),
              concatMap(spesifikasjon => this.søk(spesifikasjon)),
              tap({next: () => this.soekPaagaar.avsluttet(), error: () => this.soekPaagaar.avsluttet()})
            ),
          {initialValue: []});

        //reberegn plassering av panel når panelets innhold vokser (kun når det vokser, ikke når det minker - for å unngå hopping i plassering)
        let sisteAntallTreff = 0;
        effect(() => {
            if (this.soekeresultat().length <= sisteAntallTreff || erNil(this.panel())) return;
            sisteAntallTreff = this.soekeresultat().length;
            nårGuiErOppdatert(() => this.panel()?.updatePosition(), this.injector);
        });
    }

    /** kalles når bruker limer inn i tekst-felt */
    vedLimInn($event: ClipboardEvent) {
        debug(`vedLimInn`, $event);
        $event.preventDefault();
        $event.stopPropagation();
        const adresse = $event.clipboardData?.getData("text") ?? '';
        this.adresseForRedigering(adresse);
    }

    /** aktiverer redigeringsmodus der bruker kan redigere adresse eller søke etter entitet */
    rediger() {
        if (erTomEllerNil(this.eksisterendeLenke().adresse)) this.aktiverRedigeringsmodusForNyLenke();
        else this.aktiverRedigeringsmodusForEksisterendeLenke();

        //vi kan ikke registrer eventer på this.adressefelt med en gang, men må vente til det har blitt tegnet ut, derfor pakker vi adressefelt-signalet inn i en observable
        const adressefeltSomObserverbar = toObservable(this.adressefelt, {injector: this.injector})
          .pipe(
            map(adressefelt => adressefelt?.nativeElement),
            filter(erIkkeNil));

        //vi søkeresultat-listen når bruker klikker inn i adressefeltet
        adressefeltSomObserverbar.pipe(
          switchMap(adressefelt => fromEvent(adressefelt, 'click').pipe(logVerdiLevert('# ADRESSE KLIKK'))),
          startWith(null),
          filter(() => !this.adresseErAntattEkstern()),
          takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.visSøkeresultat());

        //gå til første innslag i søkeresultat-listen når bruker taster på pil-ned tasten
        adressefeltSomObserverbar.pipe(
          switchMap(adressefelt => fromEvent<KeyboardEvent>(adressefelt, 'keydown')),
          filter(event => event.key === Tastatur.ArrowDown),
          map(() => this.soekeresultatListing()?.options?.get(0)),
          filter(erIkkeNil),
          takeUntilDestroyed(this.destroyRef))
          .subscribe(matListOption => matListOption.focus());
    }

    oppdaterInternlenkeLenketekst() {
        let oppdatertLenketekst = this.eksisterendeInternlenkeSomLenketekst();
        const lenkespesifikasjon: InternlenkeSpesifikasjon = {
            adresse: this.eksisterendeLenke().adresse!,
            attributter: this.eksisterendeLenke().attributter as InternlenkeAttributter,
            lenketekst: oppdatertLenketekst,
            oppdaterLenketekst: true
        };
        this.vedSetAdresse.emit(lenkespesifikasjon);
    }

    protected stoetterForhaandsvisning(treff: ElasticSearchTreff<any>): boolean {
        switch (treff._type) {
            case IndeksertEntitet.sak:
                return true;
            case IndeksertEntitet.opplastetDokumentVersjon:
                return erIkkeTomStreng(treff._source.pdfdataid); //støtter kun forhåndsvisning av dokument som finnes i pdf-versjon
            default:
                return false;
        }
    }

    /** viser forhåndsvisning av søketreff */
    async visForhaandsvisning(treff: ElasticSearchTreff<any>, hendelse: MouseEvent) {
        debug('visForhaandsvisning for treff: %o', treff);
        if (this.forhaandsvisningAvTreff() == treff) return; //avbryt dersom vi allerede viser dette treffet

        this.forhaandsvisningAvTreff.set(treff);
        this.forhaandsvisningAvTreffSomDokumentversjon.set(null);
        if (treff._type == IndeksertEntitet.opplastetDokumentVersjon)
            this.forhaandsvisningAvTreffSomDokumentversjon.set(await this.avhengigheter.hentDokument(treff._id));

        this.åpneForhåndsvisningPanel(hendelse.target as HTMLElement);
    }

    /** lukker preview av søketreff */
    lukkForhaandsvisning() {
        this.forhåndsvisningPanel?.dispose();
        //opprydning gjøres indirekte av vedForhåndvisningLukket
    }

    /** emitter event med LenkeSpesifikasjon som skal registreres i editor */
    registrer() {
        if (this.skjema.invalid) return;

        const lenkespesifikasjon = erIkkeNil(this.valgtTreff()) ?
          this.lenkeSpesifikasjonFraTreff() :
          this.lenkeSpesifikasjonForAdresse();
        this.vedSetAdresse.emit(lenkespesifikasjon);
    }

    slett() {
        this.vedSlettLenke.emit();
    }

    avbryt() {
        if (this.modus() === 'ny') this.slett();
        else this.aktiverVismodus();
    }

    ngOnDestroy(): void {
        this.lukkForhaandsvisning();
    }

    //private hjelpemetoder

    private aktiverVismodus() {
        this.modus.set('vis');
    }

    private aktiverRedigeringsmodusForNyLenke() {
        debug('aktiverRedigeringsmodusForNyLenke');
        this.modus.set('ny');
        this.skjema.reset();
        this.giInputfeltFokus();
    }

    private aktiverRedigeringsmodusForEksisterendeLenke() {
        debug('aktiverRedigeringsmodusForEksisterendeLenke');
        this.modus.set('rediger');
        //dersom angitt eksisterendeLenke er en internlenke setter vi adressefeltet til lenketeksten
        //det gir ikke mening å eksponere eksisterendeLenke.adresse (url til entitet) til bruker og la bruker redigere denne urlen
        const adresse = erInternLenke(this.eksisterendeLenke().attributter) ? this.eksisterendeLenke().lenketekst : this.eksisterendeLenke().adresse;
        this.adresseForRedigering(adresse ?? '');
        this.giInputfeltFokus();
    }

    private adresseForRedigering(adresse: HttpsUrl) {
        debug(`adresseForRedigering: ${adresse}`)
        this.skjema.controls.adresse.setValue(adresse);
    }

    private giInputfeltFokus() {
        //vent til neste syklus slik at vi kan være sikre på at inputfelt har blitt tegnet ut
        //og tiptap ikke flytter fokus tilbake til editoren, verdier under 500 ser ut til å fungere dårlig
        setTimeout(() => {
            debug('giInputfeltFokus');
            this.adressefelt()!.nativeElement.focus();
        }, 500);
    }

    /** validerer url skrevet inn av bruker */
    private adresseValidator(): ValidatorFn {
        return (adresseKontroll: AbstractControl<string>) => {
            const verdi = adresseKontroll.value;
            if (erTomEllerNil(verdi)) return null;
            if (erIkkeNil(this.valgtTreff())) return null;
            if (erHttpsUrl(verdi)) return null;
            return {'ugyldigUrl': true};
        }
    }

    /** Henter angitt entitet fra indeks, returnerer null dersom entitet ikke funnet (entitet finnes ikke eller bruker har ikke tilgang) */
    private async lastElasticSearchTreffRepresentasjonAvEntitet(id: EntitetId, type: InternlenkeMålEntitetType): Promise<ElasticSearchTreff<any> | null> {
        const treff = await this.avhengigheter.hentFraIndeks(id, indeksertEntitetFraInternlenkeMålEntitetType(type));
        this.lastingAvInternlenkeSomTreffFeilet.set(erNil(treff));
        return treff;
    }

    private erAntattEksternAdresse(adresse: any): boolean {
        return erStreng(adresse) && adresse.trim().toLowerCase().startsWith('http');
    }

    private erForKortSøkestreng(søkestreng: any): boolean {
        return erStreng(søkestreng) && søkestreng.trim().length < 3;
    }

    private async søk(spesifikasjon: SøkSpesifikasjon): Promise<ElasticSearchTreff<any>[]> {
        debug('søk: %j', spesifikasjon);

        //dersom bruker endrer tekst i adressefeltet til ekstern adresse (fra ikke-ekstern) skjuler vi det søkeresultat-listen
        //merk at dersom adressefeltet initielt er en ekstern adresse vil søkeresultat-listen være skjult
        if (this.erAntattEksternAdresse(spesifikasjon.soekestreng)) {
            this.viserSoekeresultat.set(false);
            this.valgtTreff.set(null);
            return Promise.resolve([]); //ikke utfør søk
        }
        //gjenkjenn mønster for ekstern adresse og legg til påkrevet 'https://' prefiks
        if (spesifikasjon.soekestreng.startsWith('www.'))
            this.skjema.controls.adresse.setValue('https://' + spesifikasjon.soekestreng, {emitEvent: false});

        //viser gui for filtervalg og søkeresultat
        this.visSøkeresultat();

        //utfør søk kun dersom soekestreng er en streng med minst 3 tegn
        if (this.erForKortSøkestreng(spesifikasjon.soekestreng)) return Promise.resolve([]);

        try {
            const treff = await this.avhengigheter.finn(spesifikasjon);
            debug(`søk ga ${treff.length} treff`, treff);
            return treff;

        } catch (e) {
            this.meldingTilBruker.feilmelding(this.oversettelser.oversett(i18n('En feil oppstod ved søk')));
            return [];
        }
    }

    private søkespesifikasjon(skjema: SkjemaVerdier): SøkSpesifikasjon {
        let periode: ZonedDateTimePeriodeLukketSerialisert | null = null;
        if (erIkkeNil(skjema.periode?.start) && erIkkeNil(skjema.periode?.slutt))
            periode = plainDatePeriodeSomZonedDateTimePeriode(skjema.periode as PlainDatePeriode, this.gjeldendeTidssone.brukersTidssone()).somSerialiserbar()
        //dersom bruker har valgt bort alle typene i velg-soekbare-entiteter gui bruker vi this.tilgjengeligeTyper, ellers vil søke gi treff på alle typer
        let inkluderteTyper = erIkkeTomListe(skjema.inkluderteTyper) ? skjema.inkluderteTyper : this.tilgjengeligeTyper;
        return {
            soekestreng: skjema.adresse as string,
            inkluderteEntiteter: inkluderteTyper,
            periode: periode,
            inkluderteGrupper: [this.gruppeId()!]
        }
    }

    private visSøkeresultat() {
        this.viserSoekeresultat.set(true);
    }

    private skjulSøkeresultat() {
        this.viserSoekeresultat.set(false);
        this.lukkForhaandsvisning();
    }

    private lenkeSpesifikasjonForAdresse(): EksternlenkeSpesifikasjon {
        const skjemaverdier = this.skjema.value;
        const adresse = skjemaverdier.adresse as string;
        return {
            adresse: adresse,
            //bruker adresse som lenketekst dersom bruker har huket av for 'oppdaterLenketekst'
            lenketekst: this.oppdaterLenketekstKontroll ? adresse : (erIkkeTomStreng(this.eksisterendeLenke().lenketekst) ? this.eksisterendeLenke().lenketekst! : adresse),
            oppdaterLenketekst: this.oppdaterLenketekstKontroll.value!
        };
    }

    private lenkeSpesifikasjonFraTreff(): InternlenkeSpesifikasjon {
        /* lenker slik de ser ut når opprettet via ckeditor:
        <a data-autotag="true" data-type="sak" data-id="bbfe3ee8-b949-42a3-9fec-83eae149e59d" class="ckeditor-autotag ckeditor-autotag-sak" href="/app/innhold/moete/74b5f0e6-8d0e-4c31-adf4-8ccec0b2c891/sak/bbfe3ee8-b949-42a3-9fec-83eae149e59d" rel="noreferrer noopener">[sak]: 4 Agenda (Ledermøte 2)</a>
        <a data-autotag="true" data-type="dokument" data-id="cc0554e0-7315-4865-bc40-7b2cf555d843" class="ckeditor-autotag ckeditor-autotag-dokument" href="/app/innhold/dokument/cc0554e0-7315-4865-bc40-7b2cf555d843" rel="noreferrer noopener">[dokument]: prosjektstatus.pdf</a>
        Merk at vi legger til data-uuid som peker til LenkerelasjonModell representasjonen av lenken
        */
        const skjemaverdier = this.skjema.value;
        const treff = this.valgtTreff()!;
        const lenketekstFraTreff = this.lenketekstForTreff(treff);
        return {
            adresse: this.urlForTreff(treff),
            //bruker tekst generert fra treff som lenketekst dersom bruker har huket av for 'oppdaterLenketekst'
            lenketekst: this.oppdaterLenketekstKontroll.value ? lenketekstFraTreff : (erIkkeTomStreng(this.eksisterendeLenke().lenketekst) ? this.eksisterendeLenke().lenketekst! : lenketekstFraTreff),
            oppdaterLenketekst: this.oppdaterLenketekstKontroll.value!,
            attributter: {dataUuid: internlenkeUuidGenerator.ny(), dataType: internlenkeTypeFraSøketreff(treff), dataId: treff._id}
        }
    }

    private urlForTreff(treff: ElasticSearchTreff<any>): HttpsUrl {
        switch (treff._type) {
          //bruker 'entitet url' formen for alle trefftyper der dette er mulig
            case IndeksertEntitet.sak:
            case IndeksertEntitet.beslutning:
            case IndeksertEntitet.oppgave:
            case IndeksertEntitet.opplastetDokumentVersjon:
            default:
                return this.interneLenker.entitetUrl(treff._id, entitetTypeFraTreff(treff));
        }
    }

    private lenketekstForTreff(treff: ElasticSearchTreff<any>): string {
        const internlenketype = internlenkeTypeFraSøketreff(treff);
        switch (internlenketype) {
            case InternlenkeMålEntitetType.sak:
                return this.lenketekstSak(treff._source);
            case InternlenkeMålEntitetType.beslutning:
                return this.lenketekstBeslutning(treff._source);
            case InternlenkeMålEntitetType.oppgave:
                return this.lenketekstOppgave(treff._source);
            case InternlenkeMålEntitetType.opplastetDokumentVersjon:
                return this.lenketekstDokument(treff._source);
            default:
                return caseForEnumMangler(internlenketype);
        }
    }

    private lenketekstSak(kilde: SakIndeksfelterForLenketekst): string {
        return this.oversettelser.oversett(i18n('sak {nummer} {tittel} i {møtetittel} {møtenummer}, {møtedato}'), {
            nummer: kilde.nummer,
            tittel: kilde.tittel,
            møtetittel: kilde.forelderinfo.moete,
            møtenummer: kilde.forelderinfo.moetenummer,
            møtedato: this.temporalFormatering.formaterPlainDate(plainDateFraZonedDateTime(fraMillisSidenEpostTilZoneDateTime(kilde.dato, this.gjeldendeTidssone.brukersTidssone()), this.gjeldendeTidssone.brukersTidssone()))
        });
    }

    private lenketekstDokument(kilde: OpplastetDokumentVersjonIndeksfelterForLenketekst): string {
        return this.oversettelser.oversett(i18n('{filnavn}'), {
            filnavn: erIkkeTomStreng(kilde.pdfFilnavn) ? kilde.pdfFilnavn : kilde.filnavn
        });
    }

    private lenketekstBeslutning(kilde: BeslutningIndeksfelterForLenketekst): string {
        return this.oversettelser.oversett(i18n('beslutning {tittel} i {sak} {møtetittel}, {møtedato}'), {
            tittel: kilde.tittel,
            sak: kilde.forelderinfo.sak,
            møtetittel: kilde.forelderinfo.moete,
            møtedato: this.temporalFormatering.formaterPlainDate(plainDateFraZonedDateTime(lesZonedDateTimeSerialisert(kilde.forelderinfo.moetedato), this.gjeldendeTidssone.brukersTidssone()))
        });
    }

    private lenketekstOppgave(kilde: OppgaveIndeksfelterForLenketekst): string {
        //merk - kan ikke bruke 'strengMaler.somFullStreng(kilde.forelderinfo)' da strenMaler returnerer html-formatert streng
        if (erIkkeNil(kilde.forelderinfo?.noeklerOgVerdier.beslutning))
            return this.oversettelser.oversett(i18n('oppgave {tittel} under beslutning {beslutning} i {sak} {møtetittel}, {møtedato}'), {
                tittel: kilde.tittel,
                beslutning: kilde.forelderinfo!.noeklerOgVerdier.beslutning,
                sak: kilde.forelderinfo!.noeklerOgVerdier.sak,
                møtetittel: kilde.forelderinfo!.noeklerOgVerdier.moete,
                møtedato: this.temporalFormatering.formaterPlainDate(plainDateFraZonedDateTime(lesZonedDateTimeSerialisert(kilde.forelderinfo!.noeklerOgVerdier.moetedato), this.gjeldendeTidssone.brukersTidssone()))
            });
        if (erIkkeNil(kilde.forelderinfo?.noeklerOgVerdier.sak))
            return this.oversettelser.oversett(i18n('oppgave {tittel} under {sak} {møtetittel}, {møtedato}'), {
                tittel: kilde.tittel,
                sak: kilde.forelderinfo!.noeklerOgVerdier.sak,
                møtetittel: kilde.forelderinfo!.noeklerOgVerdier.moete,
                møtedato: this.temporalFormatering.formaterPlainDate(plainDateFraZonedDateTime(lesZonedDateTimeSerialisert(kilde.forelderinfo!.noeklerOgVerdier.moetedato), this.gjeldendeTidssone.brukersTidssone()))
            });

        return this.oversettelser.oversett(i18n('oppgave {tittel}'), {
            tittel: kilde.tittel,
        });
    }

    private åpneForhåndsvisningPanel(ankerElement: HTMLElement): void {
        debug('åpneForhåndsvisningPanel', ankerElement)
        this.forhåndsvisningPanel?.dispose();
        this.forhåndsvisningPanel = this.overlay.create(this.forhåndsvisningPanelKonfigurasjon(ankerElement));
        //lukk forhåndsvisning ved klikk på esc (lytter termineres av forhåndsvisningPanel.dispose, derfor ingen takeUntilDestroyed)
        this.forhåndsvisningPanel.keydownEvents()
          .pipe(filter(event => event.key == Tastatur.Escape))
          .subscribe(() => this.lukkForhaandsvisning())
        //sørg for å resette relevante tilstander når forhåndsvisning lukkes (lytter termineres av forhåndsvisningPanel.dispose, derfor ingen takeUntilDestroyed)
        this.forhåndsvisningPanel.detachments().subscribe(() => this.vedForhåndvisningLukket());

        this.forhåndsvisningPanel.attach(new TemplatePortal(this.forhåndsvisningFragment(), this.viewContainerRef));
    }

    private forhåndsvisningPanelKonfigurasjon(ankerElement: HTMLElement): OverlayConfig {
        return {
            hasBackdrop: false,
            maxHeight: '80vh', //uten denne vises dokument forskjøvet ned
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            positionStrategy: this.overlay
              .position()
              .flexibleConnectedTo(ankerElement)
              .withGrowAfterOpen(true)
              .withLockedPosition(false)
              .withViewportMargin(40) //garanterer litt luft rundt kantene
              //angir hvilket punkt på forhåndsvisningFragment (overlay) som skal plasseres på hvilket punkt på origin (ankerElement)
              //the "best" position will be selected based on how well the overlay would fit within the viewport.
              .withPositions([
                  //plasser panel nedenfor og til høyre for i-knapp
                  {originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'top'},
                  //eller, plasser nedenfor og midt under i-knapp
                  {originX: 'start', originY: 'bottom', overlayX: 'center', overlayY: 'top'}
              ])
        };
    }

    private vedForhåndvisningLukket() {
        this.forhaandsvisningAvTreff.set(null);
        this.forhaandsvisningAvTreffSomDokumentversjon.set(null);
    }
}

/** subset av {@link SakIndeksfelter} som brukes i lenketekst for saker */
type SakIndeksfelterForLenketekst = Pick<SakIndeksfelter, 'nummer' | 'tittel' | 'forelderinfo' | 'dato'>;

/** subset av {@link OpplastetDokumentVersjonIndeksfelter} som brukes i lenketekst for dokumenter */
type OpplastetDokumentVersjonIndeksfelterForLenketekst = Pick<OpplastetDokumentVersjonIndeksfelter, 'filnavn' | 'pdfFilnavn'>;

/** subset av {@link BeslutningIndeksfelter} som brukes i lenketekst for beslutninger */
type BeslutningIndeksfelterForLenketekst = Pick<BeslutningIndeksfelter, 'tittel' | 'forelderinfo'>;

/** subset av {@link OppgaveIndeksfelter} som brukes i lenketekst for oppgaver */
type OppgaveIndeksfelterForLenketekst = Pick<OppgaveIndeksfelter, 'tittel' | 'forelderinfo'>;

export interface Lenkeinformasjon {
    adresse: HttpsUrl | null;
    lenketekst: string | null;
    attributter: LenkeAttributter;
}

export interface LenkeSpesifikasjon {
    adresse: HttpsUrl;
    oppdaterLenketekst: boolean;
}

export interface EksternlenkeSpesifikasjon extends LenkeSpesifikasjon {
    lenketekst?: string;
}

export interface InternlenkeSpesifikasjon extends LenkeSpesifikasjon {
    lenketekst: string;
    attributter: InternlenkeAttributter;
}

export type EksternEllerInternLenkeSpesifikasjon = EksternlenkeSpesifikasjon & Partial<InternlenkeSpesifikasjon>;

@Injectable()
export class RiktekstRedigeringLenkeRedigerKomponentAvhengigheter {

    constructor(private søkRessurs: SøkRessursClient, private dokumentRessurs: DokumentRessursClient, private sakDatatjeneste: SakDatatjeneste) {
    }

    finn(spesifikasjon: SøkSpesifikasjon): Promise<ElasticSearchTreff<any>[]> {
        return this.søkRessurs.søk(spesifikasjon).somPromise()
          .then((resultat: ElasticSearchResultat) => resultat.hits.hits);
    }

    hentFraIndeks(id: EntitetId, type: IndeksertEntitet): Promise<ElasticSearchTreff<any> | null> {
        return this.søkRessurs.entitet({id, type}).somPromise()
          .catch(feil => null);
    }

    hentDokument(id: DokumentVersjonId): Promise<DokumentVersjonModell> {
        return this.dokumentRessurs.hentDokumentVersjon(id).somPromise()
    }

    hentSak(id: AgendaelementId): Observable<AgendaelementModellDLM> {
        return this.sakDatatjeneste.hent(id);
    }
}
